import React, { useEffect, useState } from "react";
import "../Pages/card.scss";
import Card from "../Components/Card";
import { TagButton, TagButtonAll } from "../Components/TagButtons";
import kitchen from "../assets/Georgia/003.jpg";
import hall from "../assets/Georgia/000.jpg";
import hallway from "../assets/Georgia/008.jpg";
import bedroom from "../assets/Georgia/009.jpg";
import bathroom from "../assets/Georgia/016.jpg";
import balcony from "../assets/Georgia/014.jpg";
import measurementplan from "../assets/Georgia/measurementplan.jpg";
import plan from "../assets/Georgia/Plan.jpg";
import flat from "../Components/data.json";
import { useCallback } from "react";
import Gallery from "../Components/GalleryViewer";
import { Translation } from "react-i18next";

const images = flat;

const cardsData = [
  {
    img: kitchen,
    alt: "kitchen",
    titleKey: "portfolio.title-1",
    descKey: "portfolio.description",
    tagName: "кухня",
  },
  {
    img: hall,
    alt: "hall",
    titleKey: "portfolio.title-2",
    descKey: "portfolio.description-2",
    tagName: "гостиная",
  },
  {
    img: bedroom,
    alt: "bedroom",
    titleKey: "portfolio.title-3",
    descKey: "portfolio.description-3",
    tagName: "спальня",
  },
  {
    img: bathroom,
    alt: "bathroom",
    titleKey: "portfolio.title-6",
    descKey: "portfolio.description-6",
    tagName: "ванная",
  },
  {
    img: hallway,
    alt: "hallway",
    titleKey: "portfolio.title-8",
    descKey: "portfolio.description-8",
    tagName: "прихожая",
  },
  {
    img: balcony,
    alt: "balcony",
    titleKey: "portfolio.title-22",
    descKey: "portfolio.description-22",
    tagName: "балкон",
  },
  {
    img: measurementplan,
    alt: "measurementplan",
    titleKey: "portfolio.title-16",
    descKey: "portfolio.description-16",
    tagName: "обмерный план",
  },
  {
    img: plan,
    alt: "plan",
    titleKey: "portfolio.title-11",
    descKey: "portfolio.description-11",
    tagName: "планировка",
  },
];

function FlatThree() {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images.flat_8)
      : setFilteredImages(images.flat_8.filter((image) => image.tag === tag));
  }, [tag]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.classList.add("viewer-open");
    } else {
      document.body.classList.remove("viewer-open");
    }
  }, [isViewerOpen]);

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            color: "#46669c",
          }}
        >
          <h5
            style={{ fontWeight: "600", marginLeft: "1em", marginRight: "1em" }}
          >
            {t(["portfolio.adres-8"])}
            {/*  Visualization and interior layout of the apartment. Krivoy Rog,
            Nemetska str. */}
          </h5>
          <div className="wrapper mt-4">
            {cardsData.map((card, index) => (
              <div
                className="card"
                key={index}
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                <Card
                  img={card.img}
                  alt={card.alt}
                  title={t([card.titleKey])}
                  description={t([card.descKey])}
                />
                <div onClick={() => openImageViewer(0)}>
                  <TagButton
                    name={card.tagName}
                    tagactive={tag === card.tagName}
                    handleSetTag={setTag}
                  />
                </div>
              </div>
            ))}
          </div>

          <div onClick={() => openImageViewer(0)}>
            <TagButtonAll
              name="all"
              tagactive={tag === "all" ? true : false}
              handleSetTag={setTag}
            />
          </div>
          <div>
            {isViewerOpen && (
              <Gallery
                images={filteredImages}
                startIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default FlatThree;
